function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */
import { EventEmitter } from 'events';
import Log from './log';
/**
 * AudioProcessorEventObserver observes {@link AudioProcessor}
 * related operations and re-emits them as generic events.
 * @private
 */

export var AudioProcessorEventObserver = /*#__PURE__*/function (_EventEmitter) {
  _inherits(AudioProcessorEventObserver, _EventEmitter);

  var _super = _createSuper(AudioProcessorEventObserver);

  function AudioProcessorEventObserver() {
    var _this;

    _classCallCheck(this, AudioProcessorEventObserver);

    _this = _super.call(this);
    _this._log = new Log('AudioProcessorEventObserver');

    _this._log.info('Creating AudioProcessorEventObserver instance');

    _this.on('enabled', function () {
      return _this._reEmitEvent('enabled');
    });

    _this.on('add', function () {
      return _this._reEmitEvent('add');
    });

    _this.on('remove', function () {
      return _this._reEmitEvent('remove');
    });

    _this.on('create', function () {
      return _this._reEmitEvent('create-processed-stream');
    });

    _this.on('destroy', function () {
      return _this._reEmitEvent('destroy-processed-stream');
    });

    return _this;
  }

  _createClass(AudioProcessorEventObserver, [{
    key: "destroy",
    value: function destroy() {
      this.removeAllListeners();
    }
  }, {
    key: "_reEmitEvent",
    value: function _reEmitEvent(name) {
      this._log.info("AudioProcessor:".concat(name));

      this.emit('event', {
        name: name,
        group: 'audio-processor'
      });
    }
  }]);

  return AudioProcessorEventObserver;
}(EventEmitter);